import { storeToRefs } from "pinia";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { TEnvFeatureFlag } from "@/services/feature-flags/feature-flags.types";
import { useCurrentUserStore } from "@/stores/current-user/current-user-store";

export function useFeatureFlag() {
  const { env } = useServices();
  const currentUserStore = useCurrentUserStore();
  const { currentUser } = storeToRefs(currentUserStore);

  function isEnvFeatureEnabled(envFeatureFlag: TEnvFeatureFlag) {
    const isFeatureEnabled = env[envFeatureFlag.name];
    if (isFeatureEnabled) return true;

    if (!currentUser.value) return false;

    const canUserBypass = envFeatureFlag.userBypass?.(currentUser.value);
    return !!canUserBypass;
  }

  return {
    isEnvFeatureEnabled,
  };
}
